import { render } from "./FridgeDetailsMyAssistList.vue?vue&type=template&id=6abbc837&scoped=true&ts=true"
import script from "./FridgeDetailsMyAssistList.vue?vue&type=script&lang=ts"
export * from "./FridgeDetailsMyAssistList.vue?vue&type=script&lang=ts"

import "./FridgeDetailsMyAssistList.vue?vue&type=style&index=0&id=6abbc837&lang=scss&scoped=true"

import exportComponent from "/home/smith/kitchenwebapp/kitchenwebapp/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6abbc837"]])

export default __exports__